import styled from 'styled-components';

export const Headerunit = styled.div`

   display: flex;
   margin:0px;
   width:100%;
   padding-top: 5px;
   background: #cbd9e6;

`;

export const Headertext = styled.div`

    display: flex;
    font-size: ${props=>props.fontsize}px;
    color: #23225c;
    width:100%;

`;


export const Headertextbig = styled.div`


     margin-top:${props=>props.winheight/42}px;
    height:${props=>props.winwidth/22}px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-weight: bold;
    background:#e6eef4;
    width:100%;

`;
